module.exports = __webpack_public_path__ + "pic/28.bec23793.png";